export const DEFAULT_TRAVELER_PICKER_CONTEXT = {
  recentlyPickedTraveler: [],
  travelers: [],
  divisions: [],
  fetchDivisionList: () => {},
  setSelectedEmployees: () => {},
  handleSearchValueChange: () => {},
  handleDivisionChange: () => {},
  handleSaveTravelerPicker: () => {},
};
